module.exports = __webpack_public_path__ + "static/media/god.d4a08faa.png";